import { render, staticRenderFns } from "./BlockBilling.vue?vue&type=template&id=042d172d&scoped=true"
import script from "./BlockBilling.vue?vue&type=script&lang=js"
export * from "./BlockBilling.vue?vue&type=script&lang=js"
import style0 from "./BlockBilling.vue?vue&type=style&index=0&id=042d172d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042d172d",
  null
  
)

export default component.exports